export default {
    namespaced: true,
    hanwha_dvr: {
      title: "Hanwha Video Recorder | Hanwha Video Recorders",
      name: "name",
      ip: "IP",
      user: "User | Users",
      password: "password",
      http_schema: "schema http(s)",
      rtsp_schema: "schema rtsp(s)",
      http_port: "http port",
      rtsp_port: "rtsp port",
      disk_info: "Disk Information",
      network_info: "Network Information",
      information: "Information",
      details: "Details",
      recording_days: "Recording days",
      enabled_recording_audit: "Enable recording audit",
      days_recording_audit: "Recording audit days",
      model: "Model",
      firmware_version: "Firmware version",
      build_date: "Build date",
      device_type: "Device type",
      local_ip: "Local IP",
      mac_address: "MAC address",
      groups: "Groups",
      groups_permissions: {
        export: {
          name: 'Export',
          channels: 'Channels'
        },
        general: {
          record: 'Records',
          stop_recording: 'Stop recording',
          ptz_control: 'PTZ control',
          output_control: 'Remote alarm output control',
          shutdown: 'Shutdown'
        },
        menu: {
          camera: {
            name: 'Camera',
            register: 'Register',
            channel_setup: 'Channel Setup',
            camera_setup: 'Camera Setup',
            camera_password: 'Camera Password'
          },
          device: {
            name: 'Device',
            storage_device: 'Storage Device',
            device_format: 'Device Format',
            smart: 'S.M.A.R.T',
            monitor: 'Monitor',
            text: 'Text',
            device: 'Device',
            event: 'Event'
          },
          event: {
            name: 'Event',
            nvr_sensor_detection: 'Nvr Sensor Detection',
            event_setup: 'Event Setup',
            onvif_event: 'ONVIF Event',
            event_rule: 'Event Rule',
            event_schedule: 'Schedule Event'
          },
          network:{
            name: 'Network',
            ip_port: 'IP & Port',
            ip: 'IP',
            port: 'Port',
            email: 'Email',
            smtp: 'SMTP',
            event: 'Event',
            recipient: 'Recipient',
            ddns: 'DDNS',
            ip_filtering: 'IP Filtering',
            https: 'HTTPS',
            8021: '801.1x' ,
            snmp: 'SNMP',
            dhcp: 'DHCP Server',
            p2p: 'P2P'
          },
          record: {
            name: 'Record',
            recording_schedule: 'Recording Schedule',
            record_setup: 'Record Setup',
            record_option: 'Record Option'
          },
          system: {
            name: 'System',
            date_time_laguage: 'Date/Time/Language',
            system_management: 'System Management',
            product_information: 'Product Information',
            log: 'Log',
            system_log: 'System Log',
            event_log: 'Event Log',
            export_log: 'Export Log'
          }
        },
        select_all: 'select all',
        search_channel: {
          name: 'Search channel',
          channels: 'Channels'
        }
      },
      dateTimeLanguageConfig: 'Date, time, language configuration',
      updateAdminUserPassword: 'Alterar senha de administrador',
      deviceInfo: 'Device info',
      adminRecord: 'Record admin',
      router: 'Router',
      networkConfig: 'Network config',
      auditStartAt: 'Audit start at',
      recordConfig: 'Record config'
    },
};
